import { Injectable } from '@angular/core';
import { BaseService } from '../../shared/services/base.service';
import { PatientUrl } from '../../shared/urls/patient.url';
import { ConsultationUrl } from '../../shared/urls/consultation.url';

@Injectable()
export class ViewPrescriptionService {
  constructor(public baseService: BaseService) { }
  
  getMyPrescriptions(patientId, prescriptionName, offset, limit) {
    const url = PatientUrl.PATIENT_MY_PRESCRIPTIONS.replace("{id}", patientId);
    return this.baseService.getData(url,
      {
        prescriptionName: prescriptionName,
        offset: offset,
        limit: limit
      }
    );
  }
}



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/view-prescriptions/view-prescriptions.service.ts